import { render } from "./PokemonDetails.vue?vue&type=template&id=2250a0e7&ts=true"
import script from "./PokemonDetails.vue?vue&type=script&lang=ts"
export * from "./PokemonDetails.vue?vue&type=script&lang=ts"

import "./PokemonDetails.vue?vue&type=style&index=0&id=2250a0e7&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render]])